<template>
  <div class="make-exam">
    <div class="container">
      <div class="left">
        <div class="paper">
          <div class="head">
            <h3 class="title">{{ info.examTitle }}</h3>
            <p class="info">
              <span class="num">题量: {{ info.questionList.length }}</span>
              <span class="total">满分: {{ totalScore }}</span>
              <span class="time"
                >考试时间: {{ formatDate(info.examStartTime) }} 至
                {{ formatDate(info.examEndTime) }}</span
              >
            </p>
          </div>
          <div class="questions">
            <div
              class="one-type"
              v-for="(item, idx) in cQuestionList"
              :key="idx"
            >
              <h3 class="type-title">
                {{ questionIndex(idx + 1) }}. {{ checkType(item.type) }} (共{{
                  item.questionList.length
                }}题<span>,{{ sum(item.questionList) }}分</span>)
              </h3>
              <div
                class="one"
                v-for="(q, i) in item.questionList"
                :key="q.questionId"
              >
                <component
                  :is="q.type"
                  :question="q"
                  :idx="i + 1"
                  :alreadyDo="false"
                  :hideAnswer="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <el-button
          class="s-btn"
          type="primary"
          size="small"
          @click="handleSubmit(false)"
          >交卷</el-button
        >
        <div class="countdown">
          <i class="el-icon-time"></i>
          {{ formatNumber(minutes) }}:{{ formatNumber(seconds) }}
        </div>
        <div class="questions-idx">
          <div class="one-type" v-for="(item, idx) in cQuestionList" :key="idx">
            <p class="type-title">
              {{ questionIndex(idx + 1) }}. {{ checkType(item.type) }}
              <span v-show="info.lookTypeScore"
                >({{ sum(item.questionList) }}分)</span
              >
            </p>
            <div class="idxs">
              <p
                class="idx"
                :class="{ already: q.alreadyDo }"
                v-for="(q, i) in item.questionList"
                :key="q.questionId"
                @click="goAnchor('.one-' + q.questionId)"
              >
                {{ i + 1 }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="isSub"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
      width="25%"
    >
      <p style="text-align: center">试卷已提交</p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="close"
          >我知道了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RADIO from "../../courseDetail/activity/components/radio";
import CHECKBOX from "../../courseDetail/activity/components/checkbox";
import BOOLEAN from "../../courseDetail/activity/components/boolean";
import SUPPLY from "../../courseDetail/activity/components/supply";
import ANSWER from "../../courseDetail/activity/components/answer";
import { checkType, formatDate, formatNumber, testTime } from "@/utils/index";
import { startExam, submitExam, leaveScreen } from "@/api/exam";
export default {
  name: "exam",
  components: {
    RADIO,
    CHECKBOX,
    BOOLEAN,
    SUPPLY,
    ANSWER,
  },
  data() {
    return {
      checkType,
      formatDate,
      formatNumber,
      testTime,
      info: {
        questionList: [],
      },
      cQuestionList: [],
      show: false,
      minutes: 0,
      seconds: 0,
      isSub: false,
      totalLeave: 3,
    };
  },
  created() {
    this.handleStart();
    let vm = this;
    window.onblur = function () {
      vm.info.leave++;
      vm.handleLeave();
    };
  },
  mounted() {
    window.onbeforeunload = (e) => {
      if (this.isSub || this.overLeave) return undefined;
      e = e || window.event;
      if (e) {
        e.returnValue = "";
      }
      return "";
    };
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
  },
  computed: {
    totalScore() {
      return this.info.questionList.reduce((prev, curr) => {
        return (curr.score || 0) + prev;
      }, 0);
    },
  },
  watch: {
    "info.questionList": {
      handler(val) {
        val.forEach((q) => {
          if (q.type == "SUPPLY") {
            q.alreadyDo = q.myAnswerList.some((a, i) => {
              return !!a["answer" + (i + 1)];
            });
          } else {
            q.alreadyDo = q.myAnswerList.length > 0;
          }
        });
      },
      deep: true,
    },
  },
  methods: {
    handleStart() {
      this.$loading.show();
      startExam(this.$route.query.releaseId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.info = data;
          this.cQuestionList = this.classify(data.questionList);
          let time = this.testTime(new Date(), data.endTime);
          this.seconds = time % 60;
          this.minutes = Math.floor(time / 60);
          this.countDown();
        } else {
          this.$message({
            message: msg,
            type: "error",
            onClose: () => {
              this.close();
            },
          });
        }
      });
    },
    handleLeave() {
      let vm = this;
      let tips = "";
      leaveScreen(this.info.receiveId).then(({ code, data, msg }) => {
        if (code == 0) {
          if (vm.info.leave >= vm.totalLeave) {
            tips = "你的切屏次数已达上限，出于公平考虑，你的试卷已被提交。";
            vm.handleSubmit(true, true);
          } else {
            tips = `请认真考试,你已经切屏${vm.info.leave}次!`;
          }
          vm.$alert(tips, "警告", {
            confirmButtonText: "确定",
            type: "warning",
            showClose: false,
            callback: (action) => {
              if (vm.info.leave >= vm.totalLeave) {
                vm.overLeave = true;
                vm.close();
              }
            },
          });
        } else {
          console.log(msg);
        }
      });
    },
    // 格式化题目
    classify(questions) {
      let list = [];
      if (questions) {
        questions.forEach((e) => {
          let type = e.type;
          let obj = {};
          if (list.length == 0) {
            obj.type = type;
            obj.questionList = [e];
            list.push(obj);
          } else {
            let isHas = false;
            list.forEach((item) => {
              if (item.type == type) {
                item.questionList.push(e);
                isHas = true;
              }
            });
            if (!isHas) {
              let newObj = {};
              newObj.type = type;
              newObj.questionList = [e];
              list.push(newObj);
            }
          }
        });
      }
      return list;
    },
    // 题型序号
    questionIndex(index) {
      if (index == 1) {
        return "一";
      } else if (index == 2) {
        return "二";
      } else if (index == 3) {
        return "三";
      } else if (index == 4) {
        return "四";
      } else if (index == 5) {
        return "五";
      }
    },
    // 计算总分
    sum(arr) {
      return Number(
        arr
          .reduce(function (prev, curr) {
            return curr.score + prev;
          }, 0)
          .toFixed(1)
      );
    },
    // 锚点跳转
    goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    // 倒计时
    countDown() {
      this.timer && clearInterval(this.timer);
      this.timer = window.setInterval(() => {
        if (this.seconds === 0 && this.minutes !== 0) {
          this.seconds = 59;
          this.minutes -= 1;
        } else if (this.minutes === 0 && this.seconds === 0) {
          this.seconds = 0;
          // 倒计时结束自动交卷
          if (this.info.autoSubmit) {
            this.handleSubmit(true);
          }
          window.clearInterval(this.timer);
        } else {
          this.seconds -= 1;
        }
      }, 1000);
    },
    // 交卷
    handleSubmit(auto, overLeave) {
      let notDo = 0;
      let answers = [];
      this.info.questionList.forEach((item) => {
        let answerObj = {
          answer: [],
          questionId: null,
        };
        answerObj.questionId = item.questionId;
        answerObj.answer = item.myAnswerList;
        if (item.type == "SUPPLY") {
          let arr = [];
          item.myAnswerList.forEach((s) => {
            arr.push(Object.values(s)[0]);
          });
          answerObj.answer = arr;

          item.myAnswerList.every((s) => {
            return !Object.values(s)[0];
          }) && notDo++;
        } else {
          item.myAnswerList.length == 0 && notDo++;
        }
        answers.push(answerObj);
      });

      if (auto) {
        this.$loading.show();
        submitExam({
          receiveId: this.info.receiveId,
          answers,
        }).then(({ code, msg }) => {
          this.$loading.hide();
          if (code == 0) {
            if (!overLeave) {
              this.$message.success("提交成功");
              this.isSub = true;
            }
            window.clearInterval(this.timer);
          } else {
            this.$message.error(msg);
          }
        });
        return;
      }

      let tips = notDo > 0 ? `还有${notDo}题未作答,` : "";

      let canSub =
        new Date(this.info.receiveTime).getTime() +
        this.info.examMinSubmitTime * 60 * 1000;
      let now = new Date().getTime();
      if (!this.info.examMinSubmitTime || canSub <= now) {
        this.$confirm(`${tips}确定要交卷吗?`, {
          type: "warning",
        })
          .then(() => {
            this.$loading.show();
            submitExam({
              receiveId: this.info.receiveId,
              answers,
            }).then(({ code, msg }) => {
              this.$loading.hide();
              if (code == 0) {
                this.$message.success("提交成功");
                this.isSub = true;
                window.clearInterval(this.timer);
              } else {
                this.$message.error(msg);
              }
            });
          })
          .catch(() => {});
      } else {
        this.$message.warning(
          `允许交卷时间为考试开始后${this.info.examMinSubmitTime}分钟,请继续作答`
        );
      }
    },
    close() {
      localStorage.setItem("isRefresh", true);
      window.close();
    },
  },
};
</script>

<style lang="less" scoped>
.make-exam {
  padding-top: 0 !important;
  background-color: rgb(248, 248, 248);
  .container {
    position: relative;
    padding: 20px 0;
    min-height: calc(100vh - 20px);
    text-align: left;
  }
  .left {
    display: inline-block;
    padding: 20px;
    width: calc(100% - 300px);
    height: 100%;
    background-color: #fff;
    vertical-align: top;
    overflow-y: auto;

    .paper {
      padding: 0 20px;
      .head {
        padding-bottom: 20px;
        border-bottom: solid 1px #ddd;
        .title {
          margin-bottom: 10px;
          font-size: 18px;
        }
        .info {
          color: #909399;
          span {
            margin-right: 20px;
          }
        }
      }
      .questions {
        margin-top: 20px;
        &.type-sort {
          .type-title {
            &:first-child {
              margin-top: 20px;
            }
          }
        }
        .one {
          margin: 20px 0;
          .stem {
            color: #303133;
            .type {
              margin: 0 5px;
              color: #909399;
            }
          }
          .options {
            .option {
              margin-top: 15px;
              color: #303133;
              .tag {
                margin-right: 5px;
              }
            }
          }
          .answer {
            position: relative;
            margin-top: 15px;
            padding: 16px 20px;
            background: #f8f9fa;
            border: solid #f0f3f7 1px;
            border-radius: 3px;
            &.teacher-comment {
              margin-top: 10px;
            }
            .score {
              position: absolute;
              top: 16px;
              right: 20px;
              color: #00b86e;
              span {
                font-weight: bold;
                font-size: 18px;
              }
            }
            .student-answer {
              max-width: 95%;
              margin-bottom: 10px;
            }
            .right-answer {
              max-width: 95%;
              color: #00b86e;
            }
          }
        }
      }
    }
  }
  .right {
    position: fixed;
    top: 20px;
    margin-left: 920px;
    padding: 20px;
    width: 280px;
    height: calc(100% - 40px);
    background-color: #fff;
    vertical-align: top;
    .s-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 75px;
    }
    .countdown {
      padding-bottom: 15px;
      font-size: 30px;
      border-bottom: solid 1px #ddd;
    }
    .top-info {
      padding-bottom: 20px;
      border-bottom: solid 1px #ddd;
      .info {
        display: inline-block;
        margin-left: 20px;
        vertical-align: top;
        .name {
          margin-top: 10px;
          font-size: 16px;
          color: #131b26;
        }
        .sno {
          margin-top: 10px;
          color: #8a8b99;
        }
      }
    }
    .questions-idx {
      padding-top: 15px;
      height: calc(100% - 50px - 20px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
      .one-type {
        margin-bottom: 15px;
        .type-title {
          margin-bottom: 20px;
          &:not(:first-child) {
            margin-top: 13px;
          }
        }
        .idxs {
          .idx {
            display: inline-block;
            margin-right: 13px;
            margin-bottom: 13px;
            width: 35px;
            height: 35px;
            line-height: 35px;
            background: #ffffff;
            border: solid #94c1ff 1px;
            color: #3a8bff;
            text-align: center;
            border-radius: 5px;
            cursor: pointer;
            &.already {
              color: #fff;
              background-color: #3a8bff;
              border-color: #3a8bff;
            }
          }
        }
      }
    }
  }
}
</style>